var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "column q-col-gutter-md" },
        [
          _vm.user.zohoAuthenticated
            ? _c(
                "div",
                { staticClass: "col" },
                [
                  _c("customer-select", {
                    attrs: {
                      "customer-name": _vm.watchlist.customerName,
                      error: _vm.errors.customer
                    },
                    model: {
                      value: _vm.editedWatchlistProps.customer,
                      callback: function($$v) {
                        _vm.$set(_vm.editedWatchlistProps, "customer", $$v)
                      },
                      expression: "editedWatchlistProps.customer"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("q-input", {
                attrs: {
                  label: _vm.$t("name"),
                  error: _vm.errors.name,
                  "error-message": _vm.$t("error.watchlistProps.name")
                },
                model: {
                  value: _vm.editedWatchlistProps.name,
                  callback: function($$v) {
                    _vm.$set(_vm.editedWatchlistProps, "name", $$v)
                  },
                  expression: "editedWatchlistProps.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("user-select", {
                attrs: { "initial-user": _vm.initialSeller },
                model: {
                  value: _vm.editedWatchlistProps.seller,
                  callback: function($$v) {
                    _vm.$set(_vm.editedWatchlistProps, "seller", $$v)
                  },
                  expression: "editedWatchlistProps.seller"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("q-select", {
                attrs: {
                  options: _vm.languageOptions,
                  label: _vm.$t("label.language"),
                  "fill-input": "",
                  "map-options": "",
                  "emit-value": ""
                },
                model: {
                  value: _vm.zohoLanguage,
                  callback: function($$v) {
                    _vm.zohoLanguage = $$v
                  },
                  expression: "zohoLanguage"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.watchlist.totalArea
            ? _c("div", { staticClass: "col" }, [
                _c("div", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("resultArea")) +
                      ": " +
                      _vm._s(_vm.watchlist.totalArea) +
                      "\n\t\t\t"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.dynamic
            ? _c(
                "div",
                { staticClass: "col" },
                [
                  _c("q-select", {
                    attrs: {
                      options: _vm.currencyOptions,
                      label: _vm.$t("currency"),
                      "fill-input": "",
                      "map-options": "",
                      "emit-value": ""
                    },
                    model: {
                      value: _vm.currency,
                      callback: function($$v) {
                        _vm.currency = $$v
                      },
                      expression: "currency"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !this.watchlist.uid
            ? [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.productOptions,
                        label: _vm.$t("product"),
                        "fill-input": "",
                        "map-options": "",
                        "emit-value": ""
                      },
                      model: {
                        value: _vm.product,
                        callback: function($$v) {
                          _vm.product = $$v
                        },
                        expression: "product"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.watchlistTypeOptions,
                        label: _vm.$t("label.watchlistType"),
                        "fill-input": "",
                        "map-options": "",
                        "emit-value": ""
                      },
                      model: {
                        value: _vm.dynamic,
                        callback: function($$v) {
                          _vm.dynamic = $$v
                        },
                        expression: "dynamic"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("q-separator", { attrs: { spaced: "" } }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("q-btn", {
              attrs: { label: _vm.$t("button.cancel"), flat: "" },
              on: { click: _vm.cancel }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("q-btn", {
              attrs: {
                label: this.watchlist.uid
                  ? _vm.$t("button.update")
                  : _vm.$t("button.create"),
                loading: _vm.loading,
                color: "primary"
              },
              on: { click: _vm.save }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }